import { EChartService } from '@/service/echart/echart.service';
import { GEnum } from '@/constants/enum.defination';
import { CompetencyType } from '@/constants/competencyType.enum';

export class SelfGiftRaderEchartService extends EChartService {
  selfLabel: string;
  giftLabel: string;
  competencyLabels: string[];
  competencyType: GEnum.CompetencyType;

  constructor(selfLabel: string, giftLabel: string, competencyLabels: string[], competencyType: GEnum.CompetencyType) {
    super();
    this.selfLabel = selfLabel;
    this.giftLabel = giftLabel;
    this.competencyLabels = competencyLabels;
    this.competencyType = competencyType;
  }

  /**
   * AIGROW2-184 箱ひげ図にデータテーブルを追加
   * 箱ひげ図のみにデータを表形式で表示する
   * EChartService が箱ひげ図以外のグラフでも共通なので、空配列を返すだけのものを追加しています
   * subTableColmuns
   * subTableData
   */
  get subTableColmuns(): any[] {
    return [];
  }
  get subTableData(): any[] {
    return [];
  }

  addSeries(score: any): void {
    this.series = [
      {
        type: 'radar',
        radarIndex: 0,
        symbolSize: 10,
        data: [
          {
            name: this.giftLabel,
            value: score.giftScores,
            symbol: 'none',
            lineStyle: { normal: { width: 1 } },
            areaStyle: { normal: { opacity: 0.5 } },
          },
        ],
      },
      {
        type: 'radar',
        radarIndex: 0,
        symbolSize: 10,
        data: [
          {
            name: this.selfLabel,
            value: score.selfScores,
            symbol: 'none',
            lineStyle: { normal: { width: 1 } },
            areaStyle: { normal: { opacity: 0.5 } },
          },
        ],
      },
    ];
  }

  get competencyTypeColor(): string {
    return CompetencyType.colorCode(this.competencyType);
  }

  get options() {
    return {
      legend: { data: [this.giftLabel, this.selfLabel], x: 'right', y: 'top' },
      radar: [
        {
          indicator: this.competencyLabels.map((d: string) => {
            return { text: d, max: 100 };
          }),
          symbolSize: 10,
          radius: 90,
          startAngle: 90,
          splitNumber: 6,
          center: ['50%', '53%'],
          shape: 'circle',
          name: {
            formatter: '{value}',
            textStyle: { color: this.competencyTypeColor, fontSize: 14, borderColor: this.competencyTypeColor, fontWeight: 'bold', borderWidth: 2, borderRadius: 1, padding: 3 },
          },
          splitArea: { areaStyle: { shadowColor: 'rgba(0, 0, 0, 0.1)', shadowBlur: 5 } },
          axisLine: { lineStyle: { color: 'rgba(255, 255, 255, 1)' } },
          splitLine: { lineStyle: { color: 'rgba(255, 255, 255, 1)' } },
        },
      ],
      series: this.series,
    };
  }
}
